define('ShopByModel.Collection.View', [
  'SCCollectionView',
  'ShopByModel.Details.View',
  'shop_by_model_collection.tpl',
  'jQuery'
], function (
  SCCollectionViewModule,
  GoferModelDetailsView,
  gofer_model_collection_tpl,
  jQuery
) {
  'use strict';

  var SCCollectionView = SCCollectionViewModule.SCCollectionView;

  function GoferModelCollectionView(options) {
    var self = this;

    SCCollectionView.call(this, options.collection);

    this.collection = options.collection;

    this.template = gofer_model_collection_tpl;

    this.collection.on('reset sync add remove change destroy', function () {
      self.render();
    });
  }

  GoferModelCollectionView.prototype = Object.create(SCCollectionView.prototype);
  GoferModelCollectionView.prototype.constructor = GoferModelCollectionView;

  GoferModelCollectionView.prototype.getCellViewsPerRow = function () {
    return 1;
  };

  GoferModelCollectionView.prototype.getCellViewInstance = function (model) {
    return new GoferModelDetailsView({
      model: model
    });
  };

  GoferModelCollectionView.prototype.getEvents = function () {
    return {
    };
  };

  GoferModelCollectionView.prototype.getContext = function () {
    return {};
  };

  return GoferModelCollectionView;
});
